import { useMobileControlToggles } from 'hooks/useMobileControlToggles.module'

import DeckViewAsDropdown from 'components/deckPage/filtersAndControls/DeckViewAsDropdown'
import DeckGroupByDropdown from 'components/deckPage/filtersAndControls/DeckGroupByDropdown'
import DeckSortByDropdown from 'components/deckPage/filtersAndControls/DeckSortByDropdown'
import ChangePriceSource from 'components/deckPage/filtersAndControls/ChangePriceSource'
import DeckFilter from '../DeckFilter'
import DeckLayoutPresenter from 'components/deckPage/DeckLayoutPresenter'
import { SimpleButton } from 'components/formElements/Button'

import styles from './mobileLayoutControls.module.scss'

const MobileLayoutControls = () => {
  const [mobileLayoutControls, setMobileLayoutControls] = useMobileControlToggles()

  const handleScrollToTopOfDeckContainer = () => {
    const deckContainer = document.getElementById('deck-container')

    if (!deckContainer) return

    const scrollPosition = deckContainer.getBoundingClientRect().top + window.pageYOffset - 50

    window.scrollTo({ top: scrollPosition, behavior: 'instant' })
  }

  return (
    <div className={styles.container}>
      <DeckViewAsDropdown onViewAsChange={handleScrollToTopOfDeckContainer} />
      <DeckGroupByDropdown />
      <DeckSortByDropdown />
      <ChangePriceSource />

      <DeckFilter />

      <DeckLayoutPresenter
        className={styles.layoutPresenter}
        label={'Example layouts. All layouts below can be configured using the tools above.'}
      />

      <div className={styles.optionsHeader}>Pin options above the deck</div>

      <div className={styles.cachableOptions}>
        <SimpleButton
          icon={mobileLayoutControls.view ? 'check square' : 'square outline'}
          onClick={() => setMobileLayoutControls({ view: !mobileLayoutControls.view })}>
          View as
        </SimpleButton>
        <SimpleButton
          icon={mobileLayoutControls.group ? 'check square' : 'square outline'}
          onClick={() => setMobileLayoutControls({ group: !mobileLayoutControls.group })}>
          Group by
        </SimpleButton>
        <SimpleButton
          icon={mobileLayoutControls.sort ? 'check square' : 'square outline'}
          onClick={() => setMobileLayoutControls({ sort: !mobileLayoutControls.sort })}>
          Sort by
        </SimpleButton>
        <SimpleButton
          icon={mobileLayoutControls.prices ? 'check square' : 'square outline'}
          onClick={() => setMobileLayoutControls({ prices: !mobileLayoutControls.prices })}>
          Prices
        </SimpleButton>
        <SimpleButton
          icon={mobileLayoutControls.deckFilter ? 'check square' : 'square outline'}
          onClick={() => setMobileLayoutControls({ deckFilter: !mobileLayoutControls.deckFilter })}>
          Deck filter
        </SimpleButton>
      </div>
    </div>
  )
}

export default MobileLayoutControls
